<template>
  <div></div>
</template>

<script>

export default {
  name: 'QYWXLogin',
  components: {

  },
  created () {
    if (this.$route.query.code) {
      window.open('http://192.168.81.145:8081/#/qywx_authentication?code=' + this.$route.query.code, '_blank')
    }
  }
}
</script>

<style>
</style>
